// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2X-Zy","rootSmall":"AddTileButton_rootSmall__3pbFa"};